import React, { useState } from 'react';

const TrackApplication = () => {
  const [showProgress, setShowProgress] = useState(false);
  const [searchId, setSearchId] = useState('');

  // Sample data - exactly matching the images
const applicationData = {
  nocId: 'NOC001',
  tankDetails: {
    name: 'Palur Tank',
    village: 'Palur, Cuddalore Dist'
  },
  activities: [
    'Strengthening of Pond',
    'Desilting of channel'
  ],
  status: 'Pending',
  timeline: [
    {
      title: 'Submitted by Ngo',
      date: '15th Sep, 24',
      status: 'completed',
      remarks: 'Initial submission completed',
      color: 'blue'
    },
    {
      title: 'Approved by AE/JE',
      date: '22nd Sep, 24',
      status: 'completed',
      remarks: 'Technical review completed',
      color: 'yellow'
    },
    {
      title: 'Approved by AEE',
      date: '29th Sep, 24',
      status: 'completed',
      remarks: 'Assistant Executive Engineer approval received',
      color: 'green'
    },
    {
      title: 'Pending with EE',
      date: '6th Oct, 24',
      status: 'current',
      remarks: 'Awaiting Executive Engineer review',
      color: 'red'
    }
  ]
};

  const handleSearch = () => {
    if (searchId.trim()) {
      setShowProgress(true);
    }
  };

  const handleViewProgress = () => {
    setShowProgress(true);
  };

  const handleBack = () => {
    setShowProgress(false);
    setSearchId('');
  };

  if (!showProgress) {
    // Search View - Enhanced Design
    return (
      <div className="min-h-screen bg-gradient-to-br from-slate-100 via-blue-50 to-indigo-100 py-8 md:py-20">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          {/* Header */}
          <div className="text-center mb-8 md:mb-16">
            <div className="inline-flex items-center px-4 md:px-8 py-3 md:py-4 bg-gradient-to-r from-blue-100 to-indigo-100 text-blue-700 rounded-full text-xs md:text-sm font-medium mb-6 md:mb-8 shadow-lg">
              <svg className="w-4 h-4 md:w-5 md:h-5 mr-2 md:mr-3" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
              </svg>
              Application Tracking Portal
            </div>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-light text-gray-800 mb-6 md:mb-8 leading-tight px-4">
              Track Your 
              <span className="font-semibold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent"> NOC Application</span>
            </h1>
            <p className="text-base md:text-xl text-gray-600 font-light max-w-3xl mx-auto leading-relaxed mb-8 md:mb-12 px-4">
              Monitor your water resource NOC application status in real-time. Enter your NOC ID to get detailed progress updates.
            </p>
            
            {/* Enhanced Search Box */}
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4 md:gap-6 mb-8 md:mb-16 px-4">
              <div className="relative w-full sm:flex-1 max-w-2xl">
                <div className="absolute inset-y-0 left-0 pl-4 md:pl-6 flex items-center pointer-events-none">
                  <svg className="h-5 w-5 md:h-6 md:w-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                  </svg>
                </div>
                <input
                  type="text"
                  placeholder="Enter your NOC ID (e.g., NOC001)"
                  value={searchId}
                  onChange={(e) => setSearchId(e.target.value)}
                  className="w-full pl-12 md:pl-16 pr-6 md:pr-8 py-4 md:py-6 border-2 border-gray-200 rounded-xl md:rounded-2xl focus:ring-4 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all duration-300 text-base md:text-lg shadow-lg bg-white/80 backdrop-blur-sm"
                />
              </div>
              <button
                onClick={handleSearch}
                className="w-full sm:w-auto px-8 md:px-10 py-4 md:py-6 bg-gradient-to-r from-blue-500 to-blue-600 text-white rounded-xl md:rounded-2xl hover:from-blue-600 hover:to-blue-700 transition-all duration-300 font-semibold text-base md:text-lg shadow-xl hover:shadow-2xl transform hover:-translate-y-1 focus:ring-4 focus:ring-blue-500/20"
              >
                Search Application
              </button>
            </div>
          </div>

          {/* Enhanced Search Results Table */}
          <div className="bg-white/90 backdrop-blur-sm rounded-2xl md:rounded-3xl shadow-2xl border border-gray-100 overflow-hidden">
            <div className="px-4 md:px-10 py-6 md:py-8 border-b border-gray-100 bg-gradient-to-r from-blue-50 to-indigo-50">
              <h3 className="text-xl md:text-2xl font-semibold text-gray-800 flex items-center">
                <svg className="w-5 h-5 md:w-6 md:h-6 mr-2 md:mr-3 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                </svg>
                Search Results
              </h3>
              <p className="text-gray-600 mt-2 text-sm md:text-base">Found 1 application matching your search criteria</p>
            </div>
            
            {/* Mobile Card View */}
            <div className="block md:hidden">
              <div className="p-4 border-b border-gray-100">
                <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
                  <div className="flex justify-between items-start mb-4">
                    <div className="text-blue-600 font-bold text-lg">{applicationData.nocId}</div>
                    <span className="inline-flex items-center px-3 py-2 rounded-full text-xs font-semibold bg-gradient-to-r from-yellow-100 to-orange-100 text-orange-800 shadow-sm border border-orange-200">
                      <div className="w-2 h-2 bg-orange-400 rounded-full mr-2 animate-pulse"></div>
                      {applicationData.status}
                    </span>
                  </div>
                  
                  <div className="mb-4">
                    <div className="font-semibold text-gray-900 mb-1">{applicationData.tankDetails.name}</div>
                    <div className="text-sm text-gray-600 flex items-center">
                      <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                      </svg>
                      {applicationData.tankDetails.village}
                    </div>
                  </div>
                  
                  <div className="mb-4">
                    <div className="text-sm font-medium text-gray-700 mb-2">Activities:</div>
                    <div className="flex flex-wrap gap-2">
                      {applicationData.activities.map((activity, index) => (
                        <span key={index} className="inline-block px-3 py-1 bg-gradient-to-r from-blue-100 to-blue-200 text-blue-800 text-xs rounded-lg font-medium">
                          {activity}
                        </span>
                      ))}
                    </div>
                  </div>
                  
                  <button
                    onClick={handleViewProgress}
                    className="w-full bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 py-3 rounded-xl hover:from-blue-600 hover:to-blue-700 transition-all duration-300 font-semibold shadow-lg"
                  >
                    View Progress
                  </button>
                </div>
              </div>
            </div>
            
            {/* Desktop Table View */}
            <div className="hidden md:block">
              {/* Table Header */}
              <div className="grid grid-cols-5 gap-4 lg:gap-8 px-6 lg:px-10 py-4 lg:py-6 bg-gradient-to-r from-slate-50 to-blue-50 border-b border-gray-100 text-sm lg:text-base font-semibold text-gray-700">
                <div className="flex items-center">
                  <svg className="w-4 h-4 mr-2 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M9 2a1 1 0 000 2h2a1 1 0 100-2H9z" />
                    <path fillRule="evenodd" d="M4 5a2 2 0 012-2v1a1 1 0 002 0V3a2 2 0 012 0v1a1 1 0 002 0V3a2 2 0 012 2v6h-8V5zM6 15a1 1 0 100 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  NOC ID
                </div>
                <div className="flex items-center">
                  <svg className="w-4 h-4 mr-2 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                  </svg>
                  TANK DETAILS
                </div>
                <div className="flex items-center">
                  <svg className="w-4 h-4 mr-2 text-purple-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                  </svg>
                  ACTIVITIES
                </div>
                <div className="flex items-center">
                  <svg className="w-4 h-4 mr-2 text-orange-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  STATUS
                </div>
                <div className="flex items-center">
                  <svg className="w-4 h-4 mr-2 text-indigo-600" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M3 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zm0 4a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z" clipRule="evenodd" />
                  </svg>
                  ACTIONS
                </div>
              </div>
              
              {/* Enhanced Table Row */}
              <div className="grid grid-cols-5 gap-4 lg:gap-8 px-6 lg:px-10 py-6 lg:py-8 border-b border-gray-50 items-center hover:bg-blue-25 transition-all duration-300">
                <div className="text-blue-600 font-bold text-lg lg:text-xl">{applicationData.nocId}</div>
                <div>
                  <div className="font-semibold text-gray-900 text-base lg:text-lg">{applicationData.tankDetails.name}</div>
                  <div className="text-sm text-gray-600 mt-1 flex items-center">
                    <svg className="w-3 h-3 mr-1" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd" />
                    </svg>
                    {applicationData.tankDetails.village}
                  </div>
                </div>
                <div className="flex flex-wrap gap-2">
                  {applicationData.activities.map((activity, index) => (
                    <span key={index} className="inline-block px-3 lg:px-4 py-1 lg:py-2 bg-gradient-to-r from-blue-100 to-blue-200 text-blue-800 text-xs lg:text-sm rounded-xl font-medium shadow-sm">
                      {activity}
                    </span>
                  ))}
                </div>
                <div>
                  <span className="inline-flex items-center px-4 lg:px-5 py-2 lg:py-3 rounded-full text-sm font-semibold bg-gradient-to-r from-yellow-100 to-orange-100 text-orange-800 shadow-lg border border-orange-200">
                    <div className="w-3 h-3 bg-orange-400 rounded-full mr-2 animate-pulse"></div>
                    {applicationData.status}
                  </span>
                </div>
                <div>
                  <button
                    onClick={handleViewProgress}
                    className="bg-gradient-to-r from-blue-500 to-blue-600 text-white px-6 lg:px-8 py-2 lg:py-3 rounded-xl hover:from-blue-600 hover:to-blue-700 transition-all duration-300 font-semibold shadow-lg hover:shadow-xl transform hover:-translate-y-1 focus:ring-4 focus:ring-blue-500/20"
                  >
                    View Progress
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Progress View - Enhanced Design
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50 py-8 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-8 md:mb-16">
          <div className="inline-flex items-center px-4 md:px-8 py-3 md:py-4 bg-gradient-to-r from-green-100 to-blue-100 text-green-700 rounded-full text-xs md:text-sm font-medium mb-6 md:mb-8 shadow-lg">
            <svg className="w-4 h-4 md:w-5 md:h-5 mr-2 md:mr-3" fill="currentColor" viewBox="0 0 20 20">
              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
            </svg>
            Application Progress Tracking
          </div>
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-light text-gray-800 mb-6 md:mb-8 leading-tight px-4">
            Application 
            <span className="font-semibold bg-gradient-to-r from-green-600 to-blue-600 bg-clip-text text-transparent"> Progress</span>
          </h1>
          
          {/* Search Box */}
          <div className="flex flex-col sm:flex-row justify-center items-center gap-4 md:gap-6 mb-8 md:mb-16 px-4">
            <div className="relative w-full sm:flex-1 max-w-2xl">
              <div className="absolute inset-y-0 left-0 pl-4 md:pl-6 flex items-center pointer-events-none">
                <svg className="h-5 w-5 md:h-6 md:w-6 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
              </div>
              <input
                type="text"
                value="NOC001"
                className="w-full pl-12 md:pl-16 pr-6 md:pr-8 py-4 md:py-6 border-2 border-green-200 rounded-xl md:rounded-2xl focus:ring-4 focus:ring-green-500/20 focus:border-green-500 outline-none transition-all duration-300 text-base md:text-lg shadow-lg bg-white/80 backdrop-blur-sm"
                readOnly
              />
            </div>
            <button
              onClick={handleBack}
              className="w-full sm:w-auto px-8 md:px-10 py-4 md:py-6 bg-gradient-to-r from-green-500 to-green-600 text-white rounded-xl md:rounded-2xl hover:from-green-600 hover:to-green-700 transition-all duration-300 font-semibold text-base md:text-lg shadow-xl hover:shadow-2xl transform hover:-translate-y-1"
            >
              New Search
            </button>
          </div>
        </div>

        <div className="bg-white/90 backdrop-blur-sm rounded-2xl md:rounded-3xl shadow-2xl border border-gray-100 overflow-hidden">
          <div className="px-4 md:px-10 py-6 md:py-8 border-b border-gray-100 bg-gradient-to-r from-green-50 to-blue-50">
            <h3 className="text-xl md:text-2xl font-semibold text-gray-800 flex items-center">
              <svg className="w-5 h-5 md:w-6 md:h-6 mr-2 md:mr-3 text-green-600" fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
              </svg>
              Application Found
            </h3>
            <p className="text-gray-600 mt-2 text-sm md:text-base">Showing detailed progress for NOC001</p>
          </div>
          
          {/* Mobile Summary Card */}
          <div className="block md:hidden p-4 border-b border-gray-200">
            <div className="bg-white rounded-xl p-4 shadow-sm border border-gray-100">
              <div className="flex justify-between items-start mb-4">
                <div className="text-blue-600 font-bold text-lg">{applicationData.nocId}</div>
                <span className="inline-flex items-center px-3 py-2 rounded-full text-xs font-semibold bg-gradient-to-r from-yellow-100 to-orange-100 text-orange-800 shadow-sm">
                  <div className="w-2 h-2 bg-orange-400 rounded-full mr-2 animate-pulse"></div>
                  {applicationData.status}
                </span>
              </div>
              
              <div className="mb-4">
                <div className="font-semibold text-gray-900 mb-1">{applicationData.tankDetails.name}</div>
                <div className="text-sm text-gray-600">{applicationData.tankDetails.village}</div>
              </div>
              
              <div className="mb-4">
                <div className="text-sm font-medium text-gray-700 mb-2">Activities:</div>
                <div className="flex flex-wrap gap-2">
                  {applicationData.activities.map((activity, index) => (
                    <span key={index} className="inline-block px-3 py-1 bg-gradient-to-r from-blue-100 to-blue-200 text-blue-800 text-xs rounded-lg font-medium">
                      {activity}
                    </span>
                  ))}
                </div>
              </div>
              
              <div className="text-green-600 font-semibold text-sm flex items-center">
                <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                Active Tracking
              </div>
            </div>
          </div>
          
          {/* Desktop Summary Table */}
          <div className="hidden md:block">
            <div className="grid grid-cols-5 gap-4 lg:gap-8 px-6 lg:px-10 py-4 lg:py-6 bg-gradient-to-r from-slate-50 to-blue-50 border-b border-gray-100 text-sm lg:text-base font-semibold text-gray-700">
              <div>NOC ID</div>
              <div>TANK DETAILS</div>
              <div>ACTIVITIES</div>
              <div>STATUS</div>
              <div>ACTIONS</div>
            </div>
            
            <div className="grid grid-cols-5 gap-4 lg:gap-8 px-6 lg:px-10 py-6 lg:py-8 border-b border-gray-200 items-center">
              <div className="text-blue-600 font-bold text-lg lg:text-xl">{applicationData.nocId}</div>
              <div>
                <div className="font-semibold text-gray-900 text-base lg:text-lg">{applicationData.tankDetails.name}</div>
                <div className="text-sm text-gray-600 mt-1">{applicationData.tankDetails.village}</div>
              </div>
              <div className="flex flex-wrap gap-2">
                {applicationData.activities.map((activity, index) => (
                  <span key={index} className="inline-block px-3 lg:px-4 py-1 lg:py-2 bg-gradient-to-r from-blue-100 to-blue-200 text-blue-800 text-xs lg:text-sm rounded-xl font-medium">
                    {activity}
                  </span>
                ))}
              </div>
              <div>
                <span className="inline-flex items-center px-4 lg:px-5 py-2 lg:py-3 rounded-full text-sm font-semibold bg-gradient-to-r from-yellow-100 to-orange-100 text-orange-800 shadow-lg">
                  <div className="w-3 h-3 bg-orange-400 rounded-full mr-2 animate-pulse"></div>
                  {applicationData.status}
                </span>
              </div>
              <div>
                <span className="text-green-600 font-semibold text-sm lg:text-base flex items-center">
                  <svg className="w-4 h-4 mr-2" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                  </svg>
                  Active Tracking
                </span>
              </div>
            </div>
          </div>

          {/* Progress Timeline */}
          <div className="px-4 md:px-10 py-6 md:py-10">
            <div className="mb-6 md:mb-8">
              <h4 className="text-xl md:text-2xl font-semibold text-gray-900 mb-2 md:mb-3 flex items-center">
                <svg className="w-5 h-5 md:w-6 md:h-6 mr-2 md:mr-3 text-blue-600" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                </svg>
                {applicationData.tankDetails.name} - Progress Timeline
              </h4>
              <p className="text-gray-600 text-base md:text-lg">Application ID: <span className="font-semibold text-blue-600">{applicationData.nocId}</span></p>
            </div>

            {/* Mobile Vertical Timeline */}
            <div className="block lg:hidden space-y-6">
              {applicationData.timeline.map((item, index) => (
                <div key={index} className="relative">
                  {/* Timeline Line */}
                  {index < applicationData.timeline.length - 1 && (
                    <div className="absolute left-4 top-16 w-0.5 h-16 bg-gray-200"></div>
                  )}
                  
                  {/* Progress Card */}
                  <div className={`flex items-start space-x-4 bg-white rounded-xl p-4 shadow-lg border-2 transition-all duration-300 ${
                    item.status === 'completed' 
                      ? item.color === 'blue' ? 'border-blue-200 bg-blue-50' :
                        item.color === 'yellow' ? 'border-yellow-200 bg-yellow-50' :
                        item.color === 'green' ? 'border-green-200 bg-green-50' :
                        'border-red-200 bg-red-50'
                      : item.status === 'current'
                      ? 'border-red-300 bg-red-50 ring-2 ring-red-100'
                      : 'border-gray-200 bg-gray-50'
                  }`}>
                    {/* Status Indicator */}
                    <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center ${
                      item.status === 'completed'
                        ? item.color === 'blue' ? 'bg-blue-500' :
                          item.color === 'yellow' ? 'bg-yellow-500' :
                          item.color === 'green' ? 'bg-green-500' :
                          'bg-red-500'
                        : item.status === 'current'
                        ? 'bg-red-500 animate-pulse'
                        : 'bg-gray-300'
                    }`}>
                      {item.status === 'completed' ? (
                        <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                        </svg>
                      ) : item.status === 'current' ? (
                        <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                        </svg>
                      ) : (
                        <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm0-2a6 6 0 100-12 6 6 0 000 12z" clipRule="evenodd" />
                        </svg>
                      )}
                    </div>

                    {/* Card Content */}
                    <div className="flex-1">
                      <div className="flex justify-between items-start mb-2">
                        <h5 className={`text-base font-semibold ${
                          item.color === 'blue' ? 'text-blue-700' :
                          item.color === 'yellow' ? 'text-yellow-700' :
                          item.color === 'green' ? 'text-green-700' :
                          'text-red-700'
                        }`}>
                          {item.title}
                        </h5>
                        <span className={`text-xs px-2 py-1 rounded-full font-medium ${
                          item.status === 'completed' ? 'bg-green-100 text-green-700' :
                          item.status === 'current' ? 'bg-orange-100 text-orange-700' :
                          'bg-gray-100 text-gray-700'
                        }`}>
                          {item.status === 'completed' ? 'Completed' : 
                           item.status === 'current' ? 'In Progress' : 'Pending'}
                        </span>
                      </div>
                      
                      <div className="text-sm text-gray-600 mb-2 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                        </svg>
                        {item.date}
                      </div>
                      
                      {item.remarks && (
                        <div className="bg-white/70 p-3 rounded-lg">
                          <p className="text-xs text-gray-600 leading-relaxed">{item.remarks}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Tablet Horizontal Timeline (scrollable) */}
            <div className="hidden lg:block xl:hidden">
              <div className="flex items-center justify-start space-x-4 overflow-x-auto pb-4">
                {applicationData.timeline.map((item, index) => (
                  <React.Fragment key={index}>
                    {/* Progress Card */}
                    <div className={`flex-shrink-0 w-56 bg-white rounded-xl p-5 shadow-lg border-2 transition-all duration-300 ${
                      item.status === 'completed' 
                        ? item.color === 'blue' ? 'border-blue-200 bg-blue-50' :
                          item.color === 'yellow' ? 'border-yellow-200 bg-yellow-50' :
                          item.color === 'green' ? 'border-green-200 bg-green-50' :
                          'border-red-200 bg-red-50'
                        : item.status === 'current'
                        ? 'border-red-300 bg-red-50 ring-3 ring-red-100'
                        : 'border-gray-200 bg-gray-50'
                    }`}>
                      {/* Status Indicator */}
                      <div className="flex items-center justify-between mb-3">
                        <div className={`w-7 h-7 rounded-full flex items-center justify-center ${
                          item.status === 'completed'
                            ? item.color === 'blue' ? 'bg-blue-500' :
                              item.color === 'yellow' ? 'bg-yellow-500' :
                              item.color === 'green' ? 'bg-green-500' :
                              'bg-red-500'
                            : item.status === 'current'
                            ? 'bg-red-500 animate-pulse'
                            : 'bg-gray-300'
                        }`}>
                          {item.status === 'completed' ? (
                            <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                            </svg>
                          ) : item.status === 'current' ? (
                            <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                            </svg>
                          ) : (
                            <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                              <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm0-2a6 6 0 100-12 6 6 0 000 12z" clipRule="evenodd" />
                            </svg>
                          )}
                        </div>
                        <span className={`text-xs px-2 py-1 rounded-full font-medium ${
                          item.status === 'completed' ? 'bg-green-100 text-green-700' :
                          item.status === 'current' ? 'bg-orange-100 text-orange-700' :
                          'bg-gray-100 text-gray-700'
                        }`}>
                          {item.status === 'completed' ? 'Completed' : 
                           item.status === 'current' ? 'In Progress' : 'Pending'}
                        </span>
                      </div>

                      {/* Card Content */}
                      <h5 className={`text-base font-semibold mb-2 ${
                        item.color === 'blue' ? 'text-blue-700' :
                        item.color === 'yellow' ? 'text-yellow-700' :
                        item.color === 'green' ? 'text-green-700' :
                        'text-red-700'
                      }`}>
                        {item.title}
                      </h5>
                      
                      <div className="text-sm text-gray-600 mb-3 flex items-center">
                        <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                        </svg>
                        {item.date}
                      </div>
                      
                      {item.remarks && (
                        <div className="bg-white/70 p-2 rounded-lg">
                          <p className="text-xs text-gray-600 leading-relaxed">{item.remarks}</p>
                        </div>
                      )}
                    </div>

                    {/* Arrow Separator */}
                    {index < applicationData.timeline.length - 1 && (
                      <div className="flex-shrink-0 flex items-center">
                        <svg className="w-6 h-6 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                          <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                        </svg>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>
            </div>

            {/* Desktop Horizontal Timeline Cards */}
            <div className="hidden xl:flex items-center justify-between space-x-4 overflow-x-auto pb-4">
              {applicationData.timeline.map((item, index) => (
                <React.Fragment key={index}>
                  {/* Progress Card */}
                  <div className={`flex-shrink-0 w-64 bg-white rounded-2xl p-6 shadow-lg border-2 transition-all duration-300 ${
                    item.status === 'completed' 
                      ? item.color === 'blue' ? 'border-blue-200 bg-blue-50' :
                        item.color === 'yellow' ? 'border-yellow-200 bg-yellow-50' :
                        item.color === 'green' ? 'border-green-200 bg-green-50' :
                        'border-red-200 bg-red-50'
                      : item.status === 'current'
                      ? 'border-red-300 bg-red-50 ring-4 ring-red-100'
                      : 'border-gray-200 bg-gray-50'
                  }`}>
                    {/* Status Indicator */}
                    <div className="flex items-center justify-between mb-4">
                      <div className={`w-8 h-8 rounded-full flex items-center justify-center ${
                        item.status === 'completed'
                          ? item.color === 'blue' ? 'bg-blue-500' :
                            item.color === 'yellow' ? 'bg-yellow-500' :
                            item.color === 'green' ? 'bg-green-500' :
                            'bg-red-500'
                          : item.status === 'current'
                          ? 'bg-red-500 animate-pulse'
                          : 'bg-gray-300'
                      }`}>
                        {item.status === 'completed' ? (
                          <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                          </svg>
                        ) : item.status === 'current' ? (
                          <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-12a1 1 0 10-2 0v4a1 1 0 00.293.707l2.828 2.829a1 1 0 101.415-1.415L11 9.586V6z" clipRule="evenodd" />
                          </svg>
                        ) : (
                          <svg className="w-5 h-5 text-white" fill="currentColor" viewBox="0 0 20 20">
                            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm0-2a6 6 0 100-12 6 6 0 000 12z" clipRule="evenodd" />
                          </svg>
                        )}
                      </div>
                      <span className={`text-xs px-3 py-1 rounded-full font-medium ${
                        item.status === 'completed' ? 'bg-green-100 text-green-700' :
                        item.status === 'current' ? 'bg-orange-100 text-orange-700' :
                        'bg-gray-100 text-gray-700'
                      }`}>
                        {item.status === 'completed' ? 'Completed' : 
                         item.status === 'current' ? 'In Progress' : 'Pending'}
                      </span>
                    </div>

                    {/* Card Content */}
                    <h5 className={`text-lg font-semibold mb-2 ${
                      item.color === 'blue' ? 'text-blue-700' :
                      item.color === 'yellow' ? 'text-yellow-700' :
                      item.color === 'green' ? 'text-green-700' :
                      'text-red-700'
                    }`}>
                      {item.title}
                    </h5>
                    
                    <div className="text-sm text-gray-600 mb-3 flex items-center">
                      <svg className="w-4 h-4 mr-1" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M6 2a1 1 0 00-1 1v1H4a2 2 0 00-2 2v10a2 2 0 002 2h12a2 2 0 002-2V6a2 2 0 00-2-2h-1V3a1 1 0 10-2 0v1H7V3a1 1 0 00-1-1zm0 5a1 1 0 000 2h8a1 1 0 100-2H6z" clipRule="evenodd" />
                      </svg>
                      {item.date}
                    </div>
                    
                    {item.remarks && (
                      <div className="bg-white/70 p-3 rounded-lg">
                        <p className="text-xs text-gray-600 leading-relaxed">{item.remarks}</p>
                      </div>
                    )}
                  </div>

                  {/* Arrow Separator */}
                  {index < applicationData.timeline.length - 1 && (
                    <div className="flex-shrink-0 flex items-center">
                      <svg className="w-8 h-8 text-gray-400" fill="currentColor" viewBox="0 0 20 20">
                        <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </div>
                  )}
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrackApplication;